import React, { useState } from 'react'
import "./Login.css"
import { LoginUser } from '../../Services/Operations/ProductAPI'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { useDispatch } from 'react-redux'
import { setCredentials } from '../../Store/authSlice'

/* ── Inline SVG icon helpers (no extra dep needed) ── */
const IconKey = () => (
  <svg viewBox="0 0 24 24">
    <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0 3 3L22 7l-3-3m-3.5 3.5L19 4"/>
  </svg>
)

const IconMail = () => (
  <svg viewBox="0 0 24 24">
    <rect x="2" y="4" width="20" height="16" rx="3"/>
    <path d="m2 7 10 7 10-7"/>
  </svg>
)

const IconLock = () => (
  <svg viewBox="0 0 24 24">
    <rect x="3" y="11" width="18" height="11" rx="3"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    <circle cx="12" cy="16" r="1" fill="currentColor"/>
  </svg>
)

const IconArrow = () => (
  <svg viewBox="0 0 24 24">
    <path d="M5 12h14M13 6l6 6-6 6"/>
  </svg>
)

const IconBrand = () => (
  <svg viewBox="0 0 24 24">
    <path d="M12 2 2 7l10 5 10-5-10-5Z"/>
    <path d="M2 17l10 5 10-5"/>
    <path d="M2 12l10 5 10-5"/>
  </svg>
)

/* ── Corner seal SVG ── */
const CornerSeal = () => (
  <svg className="corner-seal" viewBox="0 0 36 36" fill="none">
    <circle cx="18" cy="18" r="16" stroke="#C9962A" strokeWidth="1"/>
    <circle cx="18" cy="18" r="11" stroke="#C9962A" strokeWidth="0.5"/>
    <path d="M18 6 L19.2 15 L28 15 L21.4 20.5 L23.8 29 L18 24 L12.2 29 L14.6 20.5 L8 15 L16.8 15 Z"
      fill="#C9962A" opacity="0.6"/>
  </svg>
)

const Login = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [state, setState] = useState(0)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleLogin = async () => {
    try {
      setState(1)
      let data = { email, password }
      const res = await LoginUser(data)
      console.log(res)
      if (res.status === 200) {
        toast.success("Login successful")
        console.log({ user: res.data.data, token: res.data.token })
        dispatch(setCredentials({ user: res.data.data, token: res.data.token }))
        navigate("/")
      } else {
        toast.info("Wrong credentials")
      }
    } catch (error) {
      console.log(error)
      toast.error("Failed to login")
    } finally {
      setState(0)
    }
  }

  return (
    <div className='body'>
      <div className='form'>

        {/* Decorative corner seal */}
        <CornerSeal />

        {/* Brand / logo section */}
        <div className="login-brand">
          <div className="login-icon-wrap">
            <IconBrand />
          </div>
          <h1 className="login-title">Welcome Back</h1>
          <p className="login-subtitle">Sign in to your account</p>
        </div>

        {/* Input fields */}
        <div className="field-group">
          <div className="field-wrap">
            <label className="field-label">Email address</label>
            <div className="input-row">
             
              <input
                className="field-input"
                placeholder="you@example.com"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="field-wrap">
            <label className="field-label">Password</label>
            <div className="input-row">
             
              <input
                className="field-input"
                placeholder="Enter your password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Login button */}
        <div className="btn-wrap">
          <button
            className="login-btn"
            onClick={() => handleLogin()}
            disabled={!!state}
          >
            {state ? (
              <span className="btn-loading">
                <span className="spinner" />
                Authenticating…
              </span>
            ) : (
              <>
                Sign In
                <IconArrow />
              </>
            )}
          </button>
        </div>

     

        {/* Footer */}
        <p className="login-footer">
          Don't have an account?{' '}
          <span onClick={() => navigate("/register")}>Create one</span>
        </p>

      </div>
    </div>
  )
}

export default Login
